import { useEffect } from 'react';

export const LOCK_SCREEN_CLASS_NAME = 'lock-screen';

function lockScreen(): void {
  document.documentElement.classList.add(LOCK_SCREEN_CLASS_NAME);
}

function unlockScreen(): void {
  document.documentElement.classList.remove(LOCK_SCREEN_CLASS_NAME);
}

export default function useLockedScreen(locked: boolean): void {
  useEffect(() => {
    locked ? lockScreen() : unlockScreen();
  }, [locked]);
}
